<template>
  <div class="mainHolder">
        <div id="sec-one">
            <div class="outer">
                <div class="content notTop">
                    <div class="item">
                        <div id="leftPanel">
                            
                            
                             
                            <TopBar />
                            <p class="infoOption">Please select an option below:</p>
                            <div class="mainManu">
                                
                                <div>
                                    <router-link to="/send-message" class="navbar-brand">
                                        SEND MESSAGE
                                    </router-link>
                                </div>
                                <div>
                                    <router-link to="/history" class="navbar-brand">
                                        HISTORY
                                    </router-link>
                                </div>
                                <div><a href="/settings">SETTINGS</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="sec-two">
            <div class="outer">
                <div class="content notTop middle">
                    <div class="p15">
                        <Logo className=""/>
                        <div class="content-two">
                            <p class="sub-title">READY FOR PICK UP!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopBar from '../components/TopBar.vue'
import Logo from '../components/Logo'
import axios from "axios";
import store from '../store'
export default {
    props:[],
    components: {
        TopBar,
        Logo
    },
    data() {
        return {
            login_data: [],
            user_data: [],
            id_user: "",
            templates:[]
        };
    },
    methods:{
        
        getData(){
            
            const self = this;
            axios({
                method: "get",
                url: `templates`,
                responseType: "json",
                //data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + localStorage.getItem('token')
                }
                
                
            })
            .then(function(response) {
                if (response.data) {
                    //alert(`Thank you. Your message was successfully sent!`, 'success')
                    self.templates = response.data
                    store.commit("setTemplates", self.templates)
                }else{
                    alert(`There was an error`, 'warning')
                }

                self.sendingForm = false
            })
            .catch(error => (alert(`There was an error: ${error}`, 'warning'), (self.sendingForm = false))); 
        }
        
    },
    created(){
        this.getData()
    },

}
</script>

<style>

</style>